<template>
  <v-container>
    <v-layout>
      <v-flex xs1>
        <v-select
          :color="Theme.GREEN"
          :items="getFilterType"
          :label="'篩選'"
          item-text="text"
          item-value="key"
          v-model="filter"
          @change="changeFilterType()"
        />
      </v-flex>
      <v-flex xs2>
        <v-select
          :color="Theme.GREEN"
          :items="getStoreTargetList"
          :label="'篩選顯示名稱'"
          item-text="text"
          item-value="key"
          v-model="filterStoreType"
          @change="changeStoreType()"
        />
      </v-flex>
      <v-flex>
        <v-text-field
          v-model="searchValue"
          label="搜尋"
          :color="Theme.GREEN"
          placeholder="查詢門市名稱"
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn
          class="mr-2"
          :color="Theme.GREEN"
          dark
          @click.prevent="searchEvent"
          >搜尋</v-btn
        >
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <input
          ref="uploader"
          class="d-none"
          type="file"
          @change="onFileChanged($event)"
          accept=".xlsx,.xls"
        />
        <v-btn :color="Theme.YELLOW" dark @click.prevent="handle"
          >上傳門市</v-btn
        >
        <v-btn
          style="float: right"
          :color="Theme.PINK"
          dark
          @click.prevent="addNew"
          >新增</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          :counters="counterList"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>

    <store-detail
      :title="editView.title"
      :visible="editView.visible"
      :item-detail="editView.item"
      :show-cancel="editView.showCancel"
      :counters="editView.counters"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
    />
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import StoreDetail from "./StoreDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import { read, utils } from "xlsx";

export default {
  name: "store",
  components: {
    TableView,
    StoreDetail,
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      filter: -1,
      searchValue: "",
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list: [],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        counters: null,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
      filterStoreType: "",
      counterList: [],
    };
  },
  created() {
    this.loadCounterData();
    this.loadData();
  },
  computed: {
    ...mapGetters([]),
    getFilterType() {
      return [
        { key: -1, text: "所有" },
        { key: 0, text: "眼鏡行" },
        { key: 1, text: "藥妝" },
        { key: 2, text: "通路" },
      ];
    },
    getColumnKeys() {
      return [
        {
          value: "edit",
          text: "編輯",
          isEvent: true,
          color: this.Theme.GREEN,
          sortable: false,
        },
        { value: "name", text: "門市名稱", sortable: true },
        { value: "cellphone", text: "門市電話", sortable: false },
        { value: "time", text: "營業時間", sortable: false },
        { value: "address", text: "地址", sortable: false },
        // { value:'latitude', text:'緯度', sortable: false },
        // { value:'longitude', text:'經度', sortable: false },
        {
          value: "target",
          text: "顯示",
          options: this.getStoreTargetList,
          sortable: false,
        },
        {
          value: "storeType",
          text: "類型",
          options: this.getStoreTypeList,
          sortable: false,
        },
        { value: "vendor", text: "通路名稱", sortable: false },
        {
          value: "counter",
          text: "櫃位",
          options: this.counterList,
          sortable: false,
        },
        {
          value: "delete",
          text: "刪除",
          isEvent: true,
          color: this.Theme.YELLOW,
          sortable: false,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "getStoreList",
      "deleteStoreInfo",
      "saveMultiStore",
      "getCounterList",
    ]),
    changeFilterType() {
      this.loadData();
    },
    changeStoreType() {
      this.loadData();
    },
    async loadCounterData() {
      const res = await this.getCounterList();
      console.log(`res ${JSON.stringify(res)}`);
      if (res.data.code === 0) {
        this.counterList = res.data.body;
      }
      this.loading = false;
    },
    async loadData() {
      this.loading = true;
      let searchQuery = [];
      if (this.filter !== -1) {
        searchQuery.push({ key: "storeType", value: this.filter });
      }
      if (this.searchValue !== "") {
        searchQuery.push({ key: "name", value: this.searchValue });
      }
      if (this.filterStoreType !== "") {
        searchQuery.push({ key: "target", value: this.filterStoreType });
      }

      let query = {
        pageIndex: this.pagination.page,
        limit:
          this.pagination.itemsPerPage === -1
            ? 10000
            : this.pagination.itemsPerPage,
        searchQuery: searchQuery,
        admin: "1",
      };

      console.log(`query == ${JSON.stringify(query)}`);

      const res = await this.getStoreList(query);
      console.log(`res ${JSON.stringify(res)}`);
      if (res.data.code === 0) {
        let copyList = res.data.body.list;
        for (let i = 0; i < copyList.length; i++) {
          let element = copyList[i];

          if (element.counter) {
            const counterArray = element.counter.split(",");
              const counters =
                counterArray.length > 1
                  ? JSON.parse(element.counter)
                  : [element.counter];

              let copyCounters = new Set();
              for (let j = 0; j < counters.length; j++) {
                let counterString = counters[j];
                counterString = counterString.replaceAll(
                  /([.?*+^$[\]\\(){}])/g,
                  ""
                );
                counterString = counterString.replaceAll(/"/g, "");
                counterString = counterString.replaceAll("[]", "");
                if (counterString) {
                  copyCounters.add(counterString);
                }
              }
              element.counter = Array.from(copyCounters);
          } else {
            element.counter = [];
          }
        }
        this.list = copyList;
        this.pagination.totalItems = res.data.body.header.totalCount;

        console.log(`getStoreList ${JSON.stringify(this.list)}`);
      }
      this.loading = false;
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === "delete") {
        this.showAlert({
          title: "提示",
          content: "是否確定要刪除此門市？",
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          },
        });
      } else {
        this.editView.title = cell.key === "add" ? "新增門市" : "修改門市";
        this.editView.item = JSON.parse(JSON.stringify(cell.item));
        this.editView.visible = true;
        this.editView.counters = this.counterList || [];

        this.editView.cancelEvent = () => {
          this.editView.visible = false;
        };
        this.editView.confirmEvent = () => {
          this.editView.visible = false;
          this.loadData();
        };
      }
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.searchValue = "";
      this.filterStoreType = "";
      this.filter = -1;
      this.loadData();
    },
    async deleteEvent(item) {
      const res = await this.deleteStoreInfo({
        storeId: item.storeId,
      });

      if (res.data.code === 0) {
        this.reset();
      }
    },
    addNew() {
      this.cellEvent({
        key: "add",
        item: {
          storeId: this.uuid.v4(),
          name: "",
          time: "",
          cellphone: "",
          city: "",
          street: "",
          address: "",
          latitude: "",
          longitude: "",
          target: 0,
          storeType: 0,
          vendor: "",
          counter: [],
          products: "",
        },
      });
    },
    handle() {
      this.showAlert({
        title: "提示",
        content: "是否上傳門市？",
        confirmEvent: async () => {
          this.hideAlert();
          this.$refs.uploader.click();
        },
      });
    },
    async onFileChanged(e) {
      const files = e.target.files;
      const file = files[0];

      var reader = new FileReader();
      // const self = this;
      reader.onload = async (ev) => {
        const data = ev.target.result;
        const workbook = read(data, {
          type: "binary",
        });
        const wsname = workbook.SheetNames[0];
        const ws = utils.sheet_to_json(workbook.Sheets[wsname], { raw: false });

        if (ws && ws.length) {
          let dataArray = [];
          ws.forEach((element) => {
            const values = Object.values(element);
            const info = {
              storeId: this.uuid.v4(),
              name: values[0],
              cellphone: values[1],
              time: values[2],
              city: values[3],
              street: values[4],
              address: values[5],
              latitude: values[6],
              longitude: values[7],
              target: values[8],
              storeType: values[9],
              vendor: values[10],
              products: "",
              createdDate: new Date(),
              counter: "",
            };
            dataArray.push(info);
          });
          const info = {
            list: dataArray,
          };
          const res = await this.saveMultiStore(info);

          if (res.data.code === 0) {
            await self.loadData();
          }
        }
      };
      reader.readAsBinaryString(file);
    },
  },
};
</script>

<style scoped></style>
